import { SITE_URL, CONTACT_EMAIL, INSTAGRAM_URL } from "@/lib/config";

export const OG_IMAGE = `${SITE_URL}/og/naguara-og.jpg`;

export const organizationLd = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Naguarà",
  alternateName: "NAGUARÀ",
  url: SITE_URL,
  logo: `${SITE_URL}/brand/naguara/naguara-logo-completo-chocolate.png`,
  email: CONTACT_EMAIL,
  sameAs: [INSTAGRAM_URL],
  address: {
    "@type": "PostalAddress",
    addressLocality: "Paterna",
    addressRegion: "Valencia",
    addressCountry: "ES",
  },
});

export const websiteLd = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Naguarà",
  url: SITE_URL,
  inLanguage: "es-ES",
});

export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${SITE_URL}${it.path}`,
  })),
});

// Only verified data: no ratings, no reviews, no invented shipping details.
export const productLd = (p, lang = "es") => ({
  "@context": "https://schema.org",
  "@type": "Product",
  name: p.name,
  description: p.description?.[lang] || "",
  image: [`${SITE_URL}${p.image}`],
  sku: p.id,
  brand: { "@type": "Brand", name: "Naguarà" },
  countryOfOrigin: p.origin,
  weight: { "@type": "QuantitativeValue", value: 250, unitCode: "GRM" },
  offers: {
    "@type": "Offer",
    url: `${SITE_URL}/cafe/${p.id}`,
    priceCurrency: "EUR",
    price: Number(p.price).toFixed(2),
    itemCondition: "https://schema.org/NewCondition",
    availability:
      p.available === false
        ? "https://schema.org/OutOfStock"
        : "https://schema.org/InStock",
    seller: { "@type": "Organization", name: "Naguarà" },
  },
});

export const itemListLd = (products) => ({
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: "Cafés Naguarà",
  itemListElement: products.map((p, i) => ({
    "@type": "ListItem",
    position: i + 1,
    url: `${SITE_URL}/cafe/${p.id}`,
    name: p.name,
  })),
});

export const serviceLd = ({ name, description, path }) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name,
  description,
  serviceType: name,
  url: `${SITE_URL}${path}`,
  areaServed: { "@type": "AdministrativeArea", name: "Valencia, España" },
  provider: { "@type": "Organization", name: "Naguarà", url: SITE_URL },
});

export const courseListLd = (courses) => ({
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: "Formación Naguarà",
  itemListElement: courses.map((c, i) => ({
    "@type": "ListItem",
    position: i + 1,
    item: {
      "@type": "Course",
      name: c.t,
      description: c.d,
      url: `${SITE_URL}/formacion`,
      provider: { "@type": "Organization", name: "Naguarà", url: SITE_URL },
    },
  })),
});

export const pageLd = (type, { name, description, path }) => ({
  "@context": "https://schema.org",
  "@type": type,
  name,
  description,
  url: `${SITE_URL}${path}`,
  isPartOf: { "@type": "WebSite", name: "Naguarà", url: SITE_URL },
});
